import { NgComponentOutlet } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthStatus } from '@core/auth/auth.model';
import { AuthService } from '@core/auth/auth.service';
import { LoginComponent } from '@core/auth/login/login.component';
import { RouteGuardService } from '@core/navigation/route.guard.service';
import { RouteLayoutService } from '@core/navigation/route.layout.service';
import { AccessDeniedComponent } from '@core/pages/access-denied/access-denied.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgComponentOutlet,
    LoginComponent,
    AccessDeniedComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  authService = inject(AuthService);
  routeGuardService = inject(RouteGuardService);
  routeLayoutService = inject(RouteLayoutService);
  authStatus = computed(() => this.authService.state().status);

  layoutComponent = this.routeLayoutService.layoutFromRouteData;
  routeAllowed = computed(() => {
    const rettighed = this.routeGuardService.rettighedFromRoute();
    if (rettighed) {
      return this.authService.hasRettighed(rettighed);
    }
    return true;
  });

  protected readonly AuthStatus = AuthStatus;
}
